<template>
  <div ref="lottieContainer" />
</template>

<script>
import lottie from 'lottie-web'

export default {
  props: {
    animationData: {
      type: Object,
      required: true,
    },
    loop: {
      type: Boolean,
      default: true,
    },
    autoplay: {
      type: Boolean,
      default: true,
    },
    speed: {
      type: Number,
      default: 1,
    },
    segments: {
      type: Array,
      default: null,
    },
  },
  mounted() {
    this.loadAnimation()
  },
  methods: {
    loadAnimation() {
      const animation = lottie.loadAnimation({
        container: this.$refs.lottieContainer,
        animationData: this.animationData,
        loop: this.loop,
        autoplay: this.autoplay,
        renderer: 'svg', // ou 'canvas' ou 'html'
      })

      animation.setSpeed(this.speed)

      if (this.segments) {
        animation.playSegments(this.segments, true)
      }
    },
  },
}
</script>
